import type { LucideIcon } from 'lucide-react'
import { Info, Search } from 'lucide-react'
import { Card } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import { formatNumber } from '@/lib/utils'

export function StatCard({
  label,
  value,
  icon: Icon,
  hint,
  giaiThich,
  tone = 'primary',
  onClick,
}: {
  label: string
  value: number | string
  icon?: LucideIcon
  hint?: string
  /** Ghi chú cách tính — hiện luôn dưới số để người xem không phải đoán số này gồm gì. */
  giaiThich?: string
  tone?: 'primary' | 'success' | 'warning' | 'destructive'
  /** Có hàm này thì cả thẻ bấm được để mở bảng truy vết số liệu. */
  onClick?: () => void
}) {
  const toneMap = {
    primary: 'bg-primary/10 text-primary',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    destructive: 'bg-destructive/10 text-destructive',
  }
  return (
    <Card
      className={cn(
        'p-5',
        onClick && 'group cursor-pointer transition-shadow hover:border-primary/40 hover:shadow-md',
      )}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick() } } : undefined}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-muted-foreground">{label}</p>
          <p className="mt-2 text-3xl font-bold tabular-nums">
            {typeof value === 'number' ? formatNumber(value) : value}
          </p>
          {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
          {giaiThich && (
            <p className="mt-1.5 inline-flex items-start gap-1 text-[11px] leading-snug text-muted-foreground/90">
              <Info className="mt-0.5 h-3 w-3 shrink-0" />
              <span>{giaiThich}</span>
            </p>
          )}
          {onClick && (
            <p className="mt-1 inline-flex items-center gap-1 text-[11px] text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100">
              <Search className="h-3 w-3" />
              Bấm để xem số này ở đâu ra
            </p>
          )}
        </div>
        {Icon && (
          <div className={cn('flex h-10 w-10 items-center justify-center rounded-lg', toneMap[tone])}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
    </Card>
  )
}
